
import api from "@/api";
import { Operator } from "@/api/dtos/Operator.schema";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";

@Component({
  components: {
    EditFrame,
    EditActionButtons,
  },
})
export default class ReminderMailSettingsForm extends Vue {
  @Prop()
  operator!: Operator;

  firstReminderM = 0;
  secondReminderM = 0;

  mounted(): void {
    this.firstReminderM = moment
      .duration(this.operator.reminderMailSettings.firstReminder)
      .asMinutes();
    this.secondReminderM = moment
      .duration(this.operator.reminderMailSettings.secondReminder)
      .asMinutes();
  }

  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;

  async onSave(): Promise<void> {
    try {
      api.OperatorsApi.updateReminderMailSettings(this.operator.uuid, {
        firstReminder: moment
          .duration(this.firstReminderM, "minutes")
          .toISOString(),
        secondReminder: moment
          .duration(this.secondReminderM, "minutes")
          .toISOString(),
      });
      showToast({
        message: "Erinnerungs-E-Mail-Einstellungen erfolgreich aktualisiert",
        type: "success",
      });
    } catch (e) {
      console.error("Reminder mail settings update error:", e);
      showToast({
        response: getAxiosResponse(e),
        message:
          "Erinnerungs-E-Mail-Einstellungen konnten nicht aktualisiert werden",
        type: "error",
      });
    }
  }

  onCancel(): void {
    this.firstReminderM = moment
      .duration(this.operator.reminderMailSettings.firstReminder)
      .asMinutes();
    this.secondReminderM = moment
      .duration(this.operator.reminderMailSettings.secondReminder)
      .asMinutes();
  }
}
